import React, { useState, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { featuredProperties } from '../mock';

export default function FeaturedProperties() {
  const scrollerRef = useRef(null);
  const [hovered, setHovered] = useState(null);

  const scrollBy = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    const cardW = el.querySelector('[data-card]')?.clientWidth || 400;
    el.scrollBy({ left: dir * (cardW + 24), behavior: 'smooth' });
  };

  return (
    <section id="portfolio" className="relative bg-[#0b0b0b] pt-20 md:pt-24 pb-6 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 mb-10">
        <div className="inline-block mb-4 pb-1 border-b border-[#b39869]">
          <span className="tracking-[0.35em] text-[11px] text-[#b39869] uppercase">Portfolio</span>
        </div>
        <h2
          className="text-white text-4xl md:text-5xl leading-tight"
          style={{ fontFamily: 'Playfair Display, serif', fontWeight: 400 }}
        >
          Featured Properties
        </h2>
      </div>
      <div
        ref={scrollerRef}
        className="flex gap-6 overflow-x-auto scroll-smooth snap-x snap-mandatory px-6 md:px-12 pb-6 no-scrollbar"
        style={{ scrollbarWidth: 'none' }}
      >
        {featuredProperties.concat(featuredProperties).map((p, idx) => (
          <article
            key={`${p.id}-${idx}`}
            data-card
            onMouseEnter={() => setHovered(idx)}
            onMouseLeave={() => setHovered(null)}
            className="relative shrink-0 w-[85vw] sm:w-[520px] md:w-[620px] h-[520px] snap-start overflow-hidden group cursor-pointer"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-[1200ms] ease-out group-hover:scale-105"
              style={{ backgroundImage: `url(${p.image})` }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-black/25" />

            {/* Status badge */}
            <div className="absolute top-6 right-6">
              <span className="text-white tracking-[0.35em] text-[10px] uppercase bg-black/40 px-3 py-1 border border-white/30">
                {p.status}
              </span>
            </div>

            {/* Content */}
            <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
              <div className="text-[10px] tracking-[0.35em] uppercase text-white/75 mb-3">
                Featured Properties
              </div>
              <div
                className="text-3xl mb-1"
                style={{ fontFamily: 'Playfair Display, serif', fontWeight: 400 }}
              >
                {p.price}
              </div>
              <div
                className="text-xl mb-1"
                style={{ fontFamily: 'Playfair Display, serif', fontWeight: 400 }}
              >
                {p.address}
              </div>
              <div className="text-[12px] text-white/70 mb-4">{p.fullAddress}</div>
              {p.beds && (
                <div className="flex gap-4 text-[12px] tracking-[0.2em] uppercase text-white/85 mb-5">
                  <span>{p.beds} BD</span>
                  <span>{p.baths} BA</span>
                  <span>{p.sqft} Sq.Ft.</span>
                </div>
              )}
              <div
                className={`inline-block border-b border-[#b39869] pb-1 text-[11px] tracking-[0.35em] uppercase text-[#b39869] transition-transform duration-300 ${
                  hovered === idx ? 'translate-x-1' : ''
                }`}
              >
                Learn More →
              </div>
            </div>
          </article>
        ))}
      </div>

      {/* Arrows */}
      <button
        onClick={() => scrollBy(-1)}
        aria-label="Previous"
        className="absolute left-4 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center border border-white/40 text-white hover:bg-white/10 hover:border-[#b39869] hover:text-[#b39869] transition-colors"
      >
        <ChevronLeft className="w-5 h-5" strokeWidth={1} />
      </button>
      <button
        onClick={() => scrollBy(1)}
        aria-label="Next"
        className="absolute right-4 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center border border-white/40 text-white hover:bg-white/10 hover:border-[#b39869] hover:text-[#b39869] transition-colors"
      >
        <ChevronRight className="w-5 h-5" strokeWidth={1} />
      </button>
    </section>
  );
}
